export default __webpack_public_path__ + "static/media/logo-fm-short.2ce0b1be.svg";